export const API_BASE_URL = (window as any).configs.REACT_APP_API;
export const AUTH_BASE_URL = (window as any).configs.REACT_APP_AUTH_BASE_URL;
export const AUTH_CLIENT_ID = (window as any).configs.REACT_APP_AUTH_CLIENT_ID;
export const IS_ENCRYPTION_ENABLED = (window as any).configs.REACT_IS_ENCRYPTION_ENABLED;
export const REACT_MSTEAMS_APIGATEWAY_BASEURL = (window as any).configs.REACT_MSTEAMS_APIGATEWAY_BASEURL;
export const IS_RED_CACTUS_BUBBLE_ENABLED = (window as any).configs.REACT_IS_RED_CACTUS_BUBBLE_ENABLED;
export const IS_CHATBOT_ENABLED = (window as any).configs.REACT_IS_CHATBOT_ENABLED;